import { useTranslation } from '@shared/core/i18n';

export const useSlapAdsRegistryTranslations = () => {
  const { t } = useTranslation('slapAdsRegistry');
  const messageLine1 = t('messageLine1');
  const messageLine2 = t('messageLine2');
  const btn = t('btn');
  return {
    messageLine1,
    messageLine2,
    btn,
  };
};
